import React from 'react'
import { Link } from 'react-router-dom'
import classNames from 'classnames'
import styles from './ContentHeader.css'
import { ROUTES } from '../../constants'
import PatientIcon from 'static/images/icons/add-plus.svg'
import BackIcon from 'static/images/icons/chevron-left.svg'
import PageUpdated from '../../components/PageUpdated'
import history from '../../containers/History'
import { checkIdtfFeatureEnabled } from '../../../configs'

const ContentHeader = props => {
  const {
    showAddPatient = true,
    showCTA,
    ctaComponent: CTAComponent,
    text,
    getText,
    hasTabs,
    showLastRefresh = true,
    isLoading,
    lastUpdated,
    handleOnRefreshClick,
    enableBackButton = false,
    className,
    isFullWidth = false,
    enrollPatient = false,
    me,
  } = props

  const headerClassNames = classNames({
    [styles.header]: !hasTabs,
    [styles.headerWithTabs]: hasTabs,
    [className]: className !== undefined,
  })
  const headerTextcn = enableBackButton ? styles.headerTextWithBack : styles.headerText
  const widthController = isFullWidth ? styles.contentHeaderFullWidth : styles.contentHeaderLeftGroup
  const checkIDTFEnabled = me && checkIdtfFeatureEnabled(me)
  return (
    <header className={headerClassNames}>
      <div className={widthController}>
        {enableBackButton &&
          <button
            onClick={() => history.goBack()}
            className={styles.back}
            data-action="content-header-back"
          >
            <BackIcon />
          </button>
        }
        {text && !getText &&
          <h1 className={headerTextcn}>
            {text}
            <span className={styles.headerLine} />
          </h1>
        }
        {!text && getText &&
          getText()
        }
      </div>
      <div className={styles.contentHeaderRightGroup}>
        {showCTA && CTAComponent}
        {showAddPatient &&
          <div
            data-action="add-patient"
          >
            {checkIDTFEnabled && enrollPatient ? (
              <Link
                to={`${ROUTES.PATIENT_ENROLLMENT}?isEdit=false`}
                className={styles.addPatientBtn}
              >
                <PatientIcon />
                Enroll Patient
              </Link>
            ) : (
              <Link
                to={ROUTES.PATIENTS_ADD_NEW_PATIENT}
                className={styles.addPatientBtn}
              >
                <PatientIcon />
                Add Patient
              </Link>
            )}
          </div>
        }
        {showLastRefresh &&
          <PageUpdated
            isLoading={isLoading}
            lastUpdated={lastUpdated}
            handleOnClick={handleOnRefreshClick}
            hasTabs={hasTabs}
            me={me}
          />
        }
      </div>
    </header>
  )
}

export default ContentHeader



// WEBPACK FOOTER //
// ./src/legacy/containers/ContentHeader/ContentHeader.jsx